import React from "react";
import "./style.scss";
import { EnvironmentContextProvider } from "./context/environmentContext";
import { LegalAndPrivacyProvider } from "./context/LegalAndPrivacyContext";
import StateContextProvider from "./context/stateContext";
import RoutesWithLDAndAuthProvider from "./pages/RoutesWithLDAndAuthProvider";

const App = () => (
  <EnvironmentContextProvider>
    <LegalAndPrivacyProvider>
      <StateContextProvider>
        <RoutesWithLDAndAuthProvider />
      </StateContextProvider>
    </LegalAndPrivacyProvider>
  </EnvironmentContextProvider>
);
export default App;
